/**
 * Boost AI Search & Discovery - Analytics Tracking
 * Version: 1.1.0
 */

// IMMEDIATE EXECUTION - This must run when file loads
(function() {
  // Force console output
  try {
    console.log('%c[BOOST ANALYTICS] Script loaded at: ' + new Date().toISOString(), 'background: #4CAF50; color: white; padding: 5px; font-size: 14px;');
  } catch(e) {
    alert('Boost Analytics loaded but console.log failed');
  }
})();

// Main analytics module
(function() {
  'use strict';

  try {
    console.log('[Boost Analytics] Starting initialization...');
  } catch(e) {}

  // Configuration
  var CONFIG = {
    ENDPOINT: 'https://lambda.mybcapps.com/e',
    SESSION_KEY: 'boostSdSessionId',
    REQUEST_IDS_KEY: 'boostPFSRequestIds',
    DEBUG: true
  };

  // User Actions
  var USER_ACTION = {
    VIEW_PRODUCT: 'view_product',
    QUICK_VIEW: 'quick_view',
    ADD_TO_CART: 'add_to_cart',
    BUY_NOW: 'buy_now'
  };

  // Action Types
  var ACTION = {
    FILTER: 'filter',
    SEARCH: 'search',
    SUGGEST: 'suggest',
    RECOMMEND: 'recommend'
  };

  // Simple logger
  function log() {
    if (CONFIG.DEBUG) {
      try {
        var args = Array.prototype.slice.call(arguments);
        args.unshift('[Boost Analytics]');
        console.log.apply(console, args);
      } catch(e) {}
    }
  }

  // Generate UUID
  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Get or create session ID
  function getSessionId() {
    try {
      var sid = localStorage.getItem(CONFIG.SESSION_KEY);
      if (!sid) {
        sid = generateUUID();
        localStorage.setItem(CONFIG.SESSION_KEY, sid);
      }
      return sid;
    } catch(e) {
      return generateUUID();
    }
  }

  // Get stored request IDs
  function getRequestIds() {
    try {
      var stored = localStorage.getItem(CONFIG.REQUEST_IDS_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch(e) {
      return {};
    }
  }

  // Set request ID
  function setRequestId(actionType, rid) {
    if (!rid) return;
    try {
      var requestIds = getRequestIds();
      requestIds[actionType] = { rid: rid, timestamp: Date.now() };
      localStorage.setItem(CONFIG.REQUEST_IDS_KEY, JSON.stringify(requestIds));
      log('Request ID stored:', actionType, rid);
    } catch(e) {
      log('Error storing request ID:', e);
    }
  }

  // Get request ID for action type
  function getRequestId(actionType) {
    var requestIds = getRequestIds();
    return requestIds[actionType] ? requestIds[actionType].rid : null;
  }

  // Get current page type
  function getPageType() {
    var path = window.location.pathname;
    if (path.indexOf('/collections/') !== -1) return 'collection_page';
    if (path.indexOf('/search') !== -1) return 'search_page';
    if (path.indexOf('/products/') !== -1) return 'product_page';
    if (path.indexOf('/cart') !== -1) return 'cart_page';
    if (path === '/' || path === '') return 'home_page';
    return 'other_page';
  }

  // Get action type based on page
  function getActionType() {
    var pageType = getPageType();
    if (pageType === 'search_page') return ACTION.SEARCH;
    if (pageType === 'collection_page') return ACTION.FILTER;
    return ACTION.FILTER;
  }

  // Get search query
  function getSearchQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('q') || '';
    } catch(e) {
      return '';
    }
  }

  // Get customer ID
  function getCustomerId() {
    try {
      if (window.__st && window.__st.cid) return String(window.__st.cid);
      var meta = document.querySelector('meta[name="customer-id"]');
      if (meta && meta.content) return meta.content;
    } catch(e) {}
    return null;
  }

  // Get cart token
  var cartToken = '';
  function refreshCartToken(callback) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartToken = cart.item_count > 0 ? cart.token : '';
        log('Cart token:', cartToken ? 'received' : 'empty');
        if (callback) callback(cartToken);
      })
      .catch(function(e) {
        log('Cart fetch error:', e);
        if (callback) callback('');
      });
  }

  // Send event to analytics endpoint
  function sendEvent(data) {
    log('=== SENDING EVENT ===');
    log('User Action:', data.u);
    log('Product ID:', data.pid);
    log('Action Type:', data.a);
    log('Full Data:', JSON.stringify(data, null, 2));

    fetch(CONFIG.ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
      keepalive: true
    })
    .then(function(response) {
      log('Event sent! Status:', response.status);
    })
    .catch(function(error) {
      log('Event send error:', error);
    });
  }

  // Track an event
  function trackEvent(userAction, productId, variantId, options) {
    options = options || {};
    
    log('=== TRACKING EVENT ===');
    log('Action:', userAction);
    log('Product:', productId);
    log('Variant:', variantId);

    var actionType = options.actionType || getActionType();
    var rid = options.rid || getRequestId(actionType);

    var data = {
      tid: (typeof Shopify !== 'undefined' && Shopify.shop) ? Shopify.shop : window.location.hostname,
      eid: generateUUID(),
      sid: getSessionId(),
      t: new Date().toISOString(),
      u: userAction,
      a: actionType,
      pg: getPageType(),
      r: document.referrer || ''
    };

    if (rid) data.rid = rid;
    if (productId) data.pid = String(productId);
    if (variantId) data.vid = String(variantId);
    
    var query = options.query || getSearchQuery();
    if (query) data.qs = query;
    
    var customerId = getCustomerId();
    if (customerId) data.cid = customerId;

    // For add to cart/buy now, get cart token first
    if (userAction === USER_ACTION.ADD_TO_CART || userAction === USER_ACTION.BUY_NOW) {
      refreshCartToken(function(token) {
        data.ct = token;
        sendEvent(data);
      });
    } else {
      if (cartToken) data.ct = cartToken;
      sendEvent(data);
    }
  }

  // Find product ID from element
  function findProductId(element) {
    if (!element) return null;
    
    // Check element attributes
    var id = element.getAttribute('data-id') || 
             element.getAttribute('data-product-id') ||
             element.getAttribute('data-product');
    if (id) return id;

    // Check parent elements
    var parent = element;
    var maxDepth = 10;
    while (parent && maxDepth > 0) {
      id = parent.getAttribute('data-id') || 
           parent.getAttribute('data-product-id') ||
           parent.getAttribute('data-product');
      if (id) return id;
      parent = parent.parentElement;
      maxDepth--;
    }

    // Check for hidden product ID (on product pages)
    var hidden = document.querySelector('#hiddenProductId[data-product-id]');
    if (hidden) return hidden.getAttribute('data-product-id');

    return null;
  }

  // Find variant ID from element
  function findVariantId(element) {
    if (!element) return null;
    
    var id = element.getAttribute('data-variant-id') || element.getAttribute('data-id');
    if (id) return id;

    // Check form for variant input
    var form = element.closest('form');
    if (form) {
      var input = form.querySelector('[name="id"]');
      if (input) return input.value;
    }

    return null;
  }

  // Setup click tracking
  function setupClickTracking() {
    log('Setting up click tracking...');

    document.addEventListener('click', function(e) {
      var target = e.target;
      
      log('Click on:', target.tagName, target.className ? target.className.substring(0, 50) : '');

      // Check for product link click
      var productLink = target.closest('a[href*="/products/"]');
      if (productLink) {
        var productId = findProductId(productLink);
        if (productId) {
          log('Product click detected! ID:', productId);
          trackEvent(USER_ACTION.VIEW_PRODUCT, productId);
          return;
        }
      }

      // Check for add to cart button
      var addToCartBtn = target.closest(
        '[data-action="add-to-cart"], ' +
        '.SizeSwatch[data-variant-id], ' +
        'button[name="add"], ' +
        '.product-form__submit, ' +
        '.AddToCartButton, ' +
        '.show-size-for-mobile, ' +
        '[class*="add-to-cart"], ' +
        '[class*="addtocart"]'
      );
      
      // Also check button text content
      if (!addToCartBtn && (target.tagName === 'BUTTON' || target.closest('button'))) {
        var btn = target.tagName === 'BUTTON' ? target : target.closest('button');
        var btnText = (btn.textContent || '').toLowerCase();
        if (btnText.indexOf('add to bag') !== -1 || 
            btnText.indexOf('add to cart') !== -1 ||
            btnText.indexOf('add-to-cart') !== -1) {
          addToCartBtn = btn;
        }
      }

      if (addToCartBtn) {
        var productId = findProductId(addToCartBtn);
        var variantId = findVariantId(addToCartBtn);
        if (productId || variantId) {
          log('Add to cart detected! Product:', productId, 'Variant:', variantId);
          trackEvent(USER_ACTION.ADD_TO_CART, productId || variantId, variantId);
          return;
        }
      }

      // Check for buy now button
      var buyNowBtn = target.closest(
        '.shopify-payment-button button, ' +
        '.shopify-payment-button__button, ' +
        '[data-action="buy-now"], ' +
        '.BuyNowButton'
      );

      if (buyNowBtn) {
        var productId = findProductId(buyNowBtn);
        var variantId = findVariantId(buyNowBtn);
        if (variantId) {
          log('Buy now detected! Product:', productId, 'Variant:', variantId);
          trackEvent(USER_ACTION.BUY_NOW, productId || variantId, variantId);
          return;
        }
      }
    }, true);

    log('Click tracking setup complete!');
  }

  // Setup form tracking
  function setupFormTracking() {
    log('Setting up form tracking...');

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      log('Add to cart form submitted!');

      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      var productId = findProductId(form);

      if (variantId) {
        log('Form submit - Product:', productId, 'Variant:', variantId);
        trackEvent(USER_ACTION.ADD_TO_CART, productId || variantId, variantId);
      }
    }, true);

    log('Form tracking setup complete!');
  }

  // Debug helper
  function debug() {
    console.log('%c=== BOOST ANALYTICS DEBUG ===', 'background: #E91E63; color: white; padding: 10px; font-size: 16px;');
    console.log('Page Type:', getPageType());
    console.log('Action Type:', getActionType());
    console.log('Session ID:', getSessionId());
    console.log('Request IDs:', getRequestIds());
    console.log('Search Query:', getSearchQuery());
    console.log('Cart Token:', cartToken);
    
    console.log('\nProduct Elements on Page:');
    console.log('  [data-id]:', document.querySelectorAll('[data-id]').length);
    console.log('  [data-product-id]:', document.querySelectorAll('[data-product-id]').length);
    console.log('  .Grid__Cell:', document.querySelectorAll('.Grid__Cell').length);
    console.log('  .ProductItem:', document.querySelectorAll('.ProductItem').length);
    console.log('  a[href*="/products/"]:', document.querySelectorAll('a[href*="/products/"]').length);
    
    console.log('\nTest Commands:');
    console.log('  BoostAnalytics.testEvent()');
    console.log('  BoostAnalytics.track("view_product", "123456")');
  }

  // Test event
  function testEvent() {
    log('Sending test event...');
    trackEvent(USER_ACTION.VIEW_PRODUCT, 'TEST_123', null, { actionType: ACTION.FILTER });
    return 'Test event sent! Check Network tab for POST to lambda.mybcapps.com/e';
  }

  // Initialize
  function init() {
    try {
      console.log('%c[BOOST ANALYTICS] Initializing...', 'background: #2196F3; color: white; padding: 5px;');
      
      // Get session ID
      var sid = getSessionId();
      log('Session ID:', sid);

      // Get cart token
      refreshCartToken();

      // Setup tracking
      setupClickTracking();
      setupFormTracking();

      console.log('%c[BOOST ANALYTICS] Ready! ✓', 'background: #4CAF50; color: white; padding: 5px; font-size: 14px;');
      console.log('Page:', getPageType(), '| Action:', getActionType());
      console.log('Run BoostAnalytics.debug() for more info');
      console.log('Run BoostAnalytics.testEvent() to test');

    } catch(error) {
      console.error('[Boost Analytics] Init error:', error);
    }
  }

  // Expose globally
  window.BoostAnalytics = {
    init: init,
    debug: debug,
    testEvent: testEvent,
    track: trackEvent,
    setRequestId: setRequestId,
    getRequestId: getRequestId,
    USER_ACTION: USER_ACTION,
    ACTION: ACTION
  };

  // Auto-initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded, init immediately
    init();
  }

})();
